import React from "react";
import { Avatar, Box, Tooltip, Typography } from "@mui/material";
import { RouterOutlined } from "@mui/icons-material";

const TicketInfo = ({ contact, ticket, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.25,
      cursor: "pointer",
      flex: 1,
      minWidth: 0,
      py: 0.5,
      borderRadius: 1,
      px: 0.5,
      "&:hover": { bgcolor: "action.hover" },
      transition: "background 0.15s",
    }}
  >
    <Avatar
      src={contact.profilePicUrl}
      alt={contact.name}
      sx={{ width: 38, height: 38, flexShrink: 0, fontSize: "0.95rem" }}
    >
      {contact.name?.[0]?.toUpperCase()}
    </Avatar>

    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="subtitle2"
        fontWeight={700}
        noWrap
        lineHeight={1.25}
        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
      >
        {contact.name}
        <Typography
          component="span"
          variant="caption"
          color="text.disabled"
          sx={{ fontWeight: 400, flexShrink: 0 }}
        >
          #{ticket.ticketNumber || ticket.id}
        </Typography>
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
        {contact.number && (
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            lineHeight={1.3}
          >
            {contact.number}
          </Typography>
        )}
        {ticket.whatsapp?.name && (
          <Tooltip title={`Via ${ticket.whatsapp.name}`} placement="bottom">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.25,
                color: "text.disabled",
                flexShrink: 0,
              }}
            >
              <RouterOutlined sx={{ fontSize: 11 }} />
              <Typography variant="caption" color="text.disabled" noWrap lineHeight={1.3}>
                {ticket.whatsapp.name}
              </Typography>
            </Box>
          </Tooltip>
        )}
        {ticket.user && (
          <Typography
            variant="caption"
            color="text.disabled"
            noWrap
            lineHeight={1.3}
            sx={{ flexShrink: 0 }}
          >
            · {ticket.user.name}
          </Typography>
        )}
      </Box>
    </Box>
  </Box>
);

export default TicketInfo;
